

export default class CheckInUtils {
  
  static SortByCreatedDate = function(a, b) {
    if (!a && !b) {
      return 0;
    }
    if (a.createdDate() < b.createdDate()) {
      return -1;
    }
    if (a.createdDate() > b.createdDate()) {
      return 1;
    }
    return 0;
  }
  
}